import { Link, useNavigate } from "react-router-dom";

import { Space, Breadcrumb, Card } from "antd";
import { PageHeader } from "@ant-design/pro-layout";

import {
   Site, ApiKey
} from "../../model/model";

import ApiKeyForm from "./ApiKeyForm";
import SessionStore from "../../model/SessionStore";

function CreateSiteApiKey({ site }: { site: Site }) {
  const navigate = useNavigate();

  const onFinish = (obj: ApiKey) => {
    SessionStore.getClient().createApiKey(obj, SessionStore.getBearer()).then( () => {
      navigate(`/site/${site.id}/api-keys`);
    });
  };

  const tu :ApiKey = {id: "",
    subId: "",
    orgId: "",
    siteId: "",
    name: "",
    role: "",
    lastSeenAt: 0};

  return (
    <Space direction="vertical" style={{ width: "100%" }} size="large">
      <PageHeader
        breadcrumbRender={() => (
          <Breadcrumb>
            <Breadcrumb.Item>
              <span>Sites</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>
                <Link to={`/site/${site.id}/dash`}>{site.name}</Link>
              </span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>
                <Link to={`/site/${site.id}/api-keys`}>Site ApiKeys</Link>
              </span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>Add</span>
            </Breadcrumb.Item>
          </Breadcrumb>
        )}
        title="Add site ApiKey"
      />
      <Card>
        <ApiKeyForm initialValues={tu} site={site} onFinish={onFinish} />
      </Card>
    </Space>
  );
}

export default CreateSiteApiKey;
